import { create } from 'zustand';
import type { Trip } from 'contracts/tracking-v2/trips';

type State = {
  trip?: Trip,
}

type Actions = {
  setTrip: (trip: Trip) => void,
  resetTripStoreState: () => void,
}

const getInitialState = (): State => ({
  trip: undefined,
});

export const useTripStore = create<State & Actions>(
  (set) => ({
    ...getInitialState(),
    setTrip: (trip) => set({ trip }),
    resetTripStoreState: () => set(getInitialState()),
  }),
);